export const CONCEPTLIST_SEARCH = 'CONCEPTLIST_SEARCH';
export const CONCEPTLIST_PAGE = 'CONCEPTLIST_PAGE';
export const CONCEPTLIST_USER = 'CONCEPTLIST_USER';
